import React from "react";
import Navbar from "./components/Navbar/Navbar";
import { Route, Routes } from "react-router-dom";
import BookingForm from "./components/BookingForm/BookingForm";

import About from "./components/About/About";

import Services from "./components/Services/Services";

import "./App.css";
import ScrollToTop from "./components/ScrollToTop/ScrollToTop";

import Merci from "./components/Merci/Merci";
import Footer from "./components/Footer/Footer";
import Pages from "./components/Pages/Pages";
import NotFound404 from "./components/ErrorPage/ErrorPage";
import PolicyPage from "./components/PolicyPage/PolicyPage";
import ReviewComponent from "./components/Review/Review";

const App = () => {
  return (
    <>
      <ScrollToTop />

      <Navbar />
      <Routes>
        <Route path="/" element={<Pages />} />

        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/bookingForm" element={<BookingForm />} />
        <Route path="/ratepage" element={<ReviewComponent/>} />
      
        <Route path="/merci" element={<Merci />} />
        <Route path="/policy" element={<PolicyPage />} />
         {/* your other routes */}
  <Route path="*" element={<NotFound404 />} />
      </Routes>
      <Footer />
    </>
  );
};

export default App;
